import { CodeHighlight } from '@ui/general';
import { SonarRecord } from '@ui/records';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';
export const PeriscopeValidationRule = ({ index, onRuleClick, rule, showType }) => {
    const handleClick = useCallback(() => {
        if (onRuleClick) {
            onRuleClick(rule);
        }
    }, [rule, onRuleClick]);
    const { code, codeReferences, displayName, isActive, sonarObjectId } = rule;
    return (React.createElement(SonarRecord, { isActive: isActive, name: displayName, onClick: handleClick, showType: showType, sonarObjectId: sonarObjectId, sonarObjectType: SonarObjectType.SalesforceValidationRule },
        React.createElement(CodeHighlight, { code: code, codeReferences: codeReferences, index: index })));
};
